// Generic page-chrome behaviors that aren't tied to a specific feature area.

// === admin bar scroll state ===
// Adds a class to body when the WP admin bar would scroll off-screen on mobile,
// so the theme can drop the top offset cleanly.
function init_admin_bar_scroll() {
    function sync() {
        if (window.innerWidth > 782) {
            jQuery('body').removeClass('scrolled-past-admin-bar');
            return;
        }

        if (jQuery(window).scrollTop() > 46) {
            jQuery('body').addClass('scrolled-past-admin-bar');
        } else {
            jQuery('body').removeClass('scrolled-past-admin-bar');
        }
    }

    jQuery(window).on('scroll resize', sync);
    sync();
}

// === responsive tabs ===
// jquery.responsiveTabs is registered on the jQuery prototype by the npm
// `responsive-tabs` package, imported from main.js.
function init_responsive_tabs() {
    var $tabs = jQuery('.woocommerce-tabs');
    if (!$tabs.length || typeof $tabs.responsiveTabs !== 'function') return;
    $tabs.responsiveTabs({ startCollapsed: 'accordion' });
}

// === mega menu close ===
function init_mega_menu() {
    jQuery(document).on('click', '.mega-toggle-block, .mega-menu-toggle, .mega-close', function() {
        jQuery('.zd-shop-menu').removeClass('mega-toggle-on');
        jQuery('.mega-menu-toggle').removeClass('mega-toggle-open');
    });
}

// === bootstrap collapse chevron rotation ===
// Any [data-bs-toggle="collapse"] trigger pointing at a Bootstrap .collapse gets
// its child .bi (icon) rotated when the panel opens.
function init_collapse_chevron_rotation() {
    jQuery(document).on('show.bs.collapse', '.collapse', function() {
        var target_id = this.id;
        if (!target_id) return;

        jQuery('[data-bs-toggle="collapse"][href="#' + target_id + '"]')
            .find('.bi')
            .addClass('rotated');
    });

    jQuery(document).on('hide.bs.collapse', '.collapse', function() {
        var target_id = this.id;
        if (!target_id) return;

        jQuery('[data-bs-toggle="collapse"][href="#' + target_id + '"]')
            .find('.bi')
            .removeClass('rotated');
    });
}

// === hide WooCommerce pagination ===
// The theme provides its own pagination/filter UI; the default WC one is unwanted.
function hide_wc_pagination() {
    jQuery('.woocommerce-pagination').hide();
}

export function init() {
    init_admin_bar_scroll();
    init_responsive_tabs();
    init_mega_menu();
    init_collapse_chevron_rotation();
    hide_wc_pagination();
}
